import { breakpoint } from '@sketch/global-styles'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${breakpoint('sm')`
    flex-direction: row;
  `}
`

export const PlanWrapper = styled.div`
  flex: 1;
  position: relative;
`

export const CurrentPlan = styled.span`
  position: absolute;
  display: flex;
  align-items: center;

  width: 81px;
  inset: auto 0 -10px 0;
  margin: auto;
  z-index: 1;

  height: 20px;
  padding: 0px 8px;
  border-radius: ${({ theme }) => theme.radii.rounded};

  background-color: ${({ theme }) => theme.colors.sketch.A};
  color: ${({ theme }) => theme.colors.foreground.primary.A};
  font-size: 0.6875rem;
`
